import React from 'react';
import privacyBanner from '../images/privacy-policy-banner.jpg';
import './Policies.css';

const Policies = () => {
  const policies = [
    {
      name: 'Interest Rate Policy',
      icon: '✓'
    },
    {
      name: 'Fair Practice Code',
      icon: '✓'
    },
    {
      name: 'Code of Fair Disclosure',
      icon: '📄'
    },
    {
      name: 'Documents Preservation Archival Policy',
      icon: '📄'
    },
    {
      name: 'Prevention of Sexual Harassment Policy',
      icon: '📄'
    },
    {
      name: 'Related Party Transaction Policy',
      icon: '📄'
    },
    {
      name: 'KYC Policy',
      icon: '📄'
    }
  ];

  return (
    <div className="policies-page">
      {/* Banner Section */}
      <section className="policies-banner">
        <div className="policies-banner-wrapper">
          <div className="banner-image" style={{ backgroundImage: `url(${privacyBanner})` }}>
            <div className="banner-overlay">
              <h1 className="banner-heading">AMPIRE FINANCE</h1>
            </div>
          </div>
          <div className="banner-content">
            <h2 className="banner-title">POLICIES</h2>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="policies-content">
        <div className="policies-wrapper">
          <div className="policies-list">
            {policies.map((policy, index) => (
              <div key={index} className="policy-item">
                <div className="policy-icon">{policy.icon}</div>
                <div className="policy-name">{policy.name}</div>
                <div className="policy-arrow">↗</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Policies;



